module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, _vm._l((_vm.projectSummaryCards), function(card, i) {
    return _c('v-flex', {
      key: i
    }, [_c('v-card', {
      staticClass: "pa-2 ma-1 text-xs-center"
    }, [_c('v-progress-circular', {
      attrs: {
        "size": 70,
        "width": 10,
        "rotate": 360,
        "value": _vm.projectStates[i] / _vm.totalProjects * 100,
        "color": card.color
      }
    }, [_vm._v("\n          " + _vm._s(_vm.projectStates[i]) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(card.title))])], 1)], 1)
  }), 1), _vm._v(" "), _c('v-card', {
    staticClass: "mt-2 mb-3"
  }, [_c('v-card-title', [_c('v-dialog', {
    attrs: {
      "max-width": "90%"
    },
    model: {
      value: (_vm.projectDialog),
      callback: function($$v) {
        _vm.projectDialog = $$v
      },
      expression: "projectDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "mb-0 pb-0"
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('span', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.projectFormTitle))])])], 1), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [(_vm.gettingNewProjectId) ? _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary",
      "size": "50"
    }
  })], 1) : _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "type": "error",
      "dismissible": ""
    },
    model: {
      value: (_vm.saveProjectFailed),
      callback: function($$v) {
        _vm.saveProjectFailed = $$v
      },
      expression: "saveProjectFailed"
    }
  }, [_vm._v("An error occured when trying to save the project. Please try again.")]), _vm._v(" "), _c('v-form', {
    ref: "newProjectForm",
    model: {
      value: (_vm.newProjectValid),
      callback: function($$v) {
        _vm.newProjectValid = $$v
      },
      expression: "newProjectValid"
    }
  }, [_c('v-subheader', [_vm._v("General")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "box": "",
      "readonly": "",
      "label": "Project ID"
    },
    model: {
      value: (_vm.editedProject.projectId),
      callback: function($$v) {
        _vm.$set(_vm.editedProject, "projectId", $$v)
      },
      expression: "editedProject.projectId"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "box": "",
      "label": "Created Date",
      "value": _vm._f("formatDate")(_vm.editedProject.CreatedDate),
      "readonly": ""
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-select', {
    attrs: {
      "box": "",
      "label": "Priority",
      "item-text": "text",
      "item-value": "value",
      "items": [{
        text: 'High',
        value: 1
      }, {
        text: 'Medium',
        value: 2
      }, {
        text: 'Low',
        value: 3
      }]
    },
    model: {
      value: (_vm.editedProject.priority),
      callback: function($$v) {
        _vm.$set(_vm.editedProject, "priority", $$v)
      },
      expression: "editedProject.priority"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "box": "",
      "label": "Job Type",
      "items": ['Order', 'Service Call']
    },
    model: {
      value: (_vm.editedProject.jobType),
      callback: function($$v) {
        _vm.$set(_vm.editedProject, "jobType", $$v)
      },
      expression: "editedProject.jobType"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "box": "",
      "label": "Project Status",
      "items": ['CTN Sheet Approved', 'In Progress', 'Complete', 'Cancelled', 'In Query'],
      "clearable": ""
    },
    model: {
      value: (_vm.editedProject.Status),
      callback: function($$v) {
        _vm.$set(_vm.editedProject, "Status", $$v)
      },
      expression: "editedProject.Status"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "box": "",
      "label": "Project Manager(s)",
      "readonly": ""
    },
    model: {
      value: (_vm.editedProject.manager),
      callback: function($$v) {
        _vm.$set(_vm.editedProject, "manager", $$v)
      },
      expression: "editedProject.manager"
    }
  })], 1)], 1), _vm._v(" "), _c('v-subheader', [_vm._v("Supplier")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "box": "",
      "label": "Assign to Supplier",
      "items": _vm.suppliers,
      "item-text": "name",
      "item-value": "key",
      "clearable": ""
    },
    model: {
      value: (_vm.editedProject.Supplier),
      callback: function($$v) {
        _vm.$set(_vm.editedProject, "Supplier", $$v)
      },
      expression: "editedProject.Supplier"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "box": "",
      "type": "number",
      "label": "Supplier Cost",
      "prefix": "£"
    },
    model: {
      value: (_vm.editedProject.supplierCost),
      callback: function($$v) {
        _vm.$set(_vm.editedProject, "supplierCost", $$v)
      },
      expression: "editedProject.supplierCost"
    }
  })], 1)], 1), _vm._v(" "), _c('v-subheader', [_vm._v("Zendesk")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "box": "",
      "label": "Zendesk - Customer Ticket"
    },
    model: {
      value: (_vm.editedProject.customerTicket),
      callback: function($$v) {
        _vm.$set(_vm.editedProject, "customerTicket", $$v)
      },
      expression: "editedProject.customerTicket"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "box": "",
      "label": "Zendesk - BDM Order Ticket"
    },
    model: {
      value: (_vm.editedProject.BDMTicket),
      callback: function($$v) {
        _vm.$set(_vm.editedProject, "BDMTicket", $$v)
      },
      expression: "editedProject.BDMTicket"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "box": "",
      "label": "Zendesk - Engineer Ticket"
    },
    model: {
      value: (_vm.editedProject.engineerTicket),
      callback: function($$v) {
        _vm.$set(_vm.editedProject, "engineerTicket", $$v)
      },
      expression: "editedProject.engineerTicket"
    }
  })], 1)], 1), _vm._v(" "), _c('v-subheader', [_vm._v("Finance - Customer")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "box": "",
      "label": "Finance Status - Customer",
      "items": ['Not Started', 'Invoiced', 'No Costs to Invoice', 'Query'],
      "clearable": ""
    },
    model: {
      value: (_vm.editedProject.financeCustomer),
      callback: function($$v) {
        _vm.$set(_vm.editedProject, "financeCustomer", $$v)
      },
      expression: "editedProject.financeCustomer"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "box": "",
      "label": "Finance - Customer Invoiced",
      "type": "number",
      "step": "0.01",
      "prefix": "£"
    },
    model: {
      value: (_vm.editedProject.financeInvoiced),
      callback: function($$v) {
        _vm.$set(_vm.editedProject, "financeInvoiced", $$v)
      },
      expression: "editedProject.financeInvoiced"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [(_vm.editedProject.jobType === 'Service Call') ? _c('v-text-field', {
    attrs: {
      "box": "",
      "label": "Customer PO Number"
    },
    model: {
      value: (_vm.editedProject.customerPO),
      callback: function($$v) {
        _vm.$set(_vm.editedProject, "customerPO", $$v)
      },
      expression: "editedProject.customerPO"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [(_vm.editedProject.jobType === 'Service Call') ? _c('v-text-field', {
    attrs: {
      "box": "",
      "label": "Customer Cost",
      "type": "number",
      "step": "0.01",
      "prefix": "£"
    },
    model: {
      value: (_vm.editedProject.customerCost),
      callback: function($$v) {
        _vm.$set(_vm.editedProject, "customerCost", $$v)
      },
      expression: "editedProject.customerCost"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-subheader', [_vm._v("Finance - Supplier")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "box": "",
      "label": "Finance Status - Supplier",
      "items": ['Not Started', 'In Query', 'Supplier part Paid', 'Complete - Supplier Paid', 'Complete - No Cost'],
      "clearable": ""
    },
    model: {
      value: (_vm.editedProject.financeSupplier),
      callback: function($$v) {
        _vm.$set(_vm.editedProject, "financeSupplier", $$v)
      },
      expression: "editedProject.financeSupplier"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "box": "",
      "label": "Supplier Amount Paid",
      "type": "number",
      "step": "0.01",
      "prefix": "£"
    },
    model: {
      value: (_vm.editedProject.supplierPaid),
      callback: function($$v) {
        _vm.$set(_vm.editedProject, "supplierPaid", $$v)
      },
      expression: "editedProject.supplierPaid"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "box": "",
      "label": "Supplier Invoice Numbers"
    },
    model: {
      value: (_vm.editedProject.supplierInvoiceNumbers),
      callback: function($$v) {
        _vm.$set(_vm.editedProject, "supplierInvoiceNumbers", $$v)
      },
      expression: "editedProject.supplierInvoiceNumbers"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "outline": "",
      "label": "Notes"
    },
    model: {
      value: (_vm.editedProject.notes),
      callback: function($$v) {
        _vm.$set(_vm.editedProject, "notes", $$v)
      },
      expression: "editedProject.notes"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list', {
    staticClass: "mt-3",
    attrs: {
      "avatar": ""
    }
  }, _vm._l((_vm.editedProject.attachedDocs), function(doc) {
    return _c('v-list-tile', {
      key: doc.name
    }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("mdi-file-document-outline")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_c('a', {
      attrs: {
        "href": doc.downloadUrl,
        "target": "_BLANK"
      }
    }, [_vm._v(_vm._s(doc.name))])])], 1)], 1)
  }), 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red darken-1",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.deleteProjectModal(_vm.editedProject)
      }
    }
  }, [_vm._v("Delete Project")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeProject($event)
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "flat": "",
      "disabled": !_vm.newProjectValid,
      "loading": _vm.savingSaveProject
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveProject(true)
      }
    }
  }, [_vm._v("Save")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "px-2",
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Filter by Project Status",
      "items": _vm.projectSummaryCards,
      "item-value": "title",
      "item-text": "title",
      "clearable": "",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.projectStatusFilter),
      callback: function($$v) {
        _vm.projectStatusFilter = $$v
      },
      expression: "projectStatusFilter"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "px-2",
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Filter by Finance Customer Status",
      "items": _vm.financeCustomerStatuses,
      "clearable": "",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.financeCustomerStatusFilter),
      callback: function($$v) {
        _vm.financeCustomerStatusFilter = $$v
      },
      expression: "financeCustomerStatusFilter"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "px-2",
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Filter by Finance Supplier Status",
      "items": _vm.financeSupplierStatuses,
      "clearable": "",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.financeSupplierStatusFilter),
      callback: function($$v) {
        _vm.financeSupplierStatusFilter = $$v
      },
      expression: "financeSupplierStatusFilter"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "px-2",
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.searchProject),
      callback: function($$v) {
        _vm.searchProject = $$v
      },
      expression: "searchProject"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.projectHeaders,
      "items": _vm.filteredProjects,
      "search": _vm.searchProject,
      "item-key": "id",
      "loading": _vm.projectTableLoading,
      "pagination": _vm.projectsPagination
    },
    on: {
      "update:pagination": function($event) {
        _vm.projectsPagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
              props.expanded = !props.expanded;
              _vm.activeProject = props.item.projectId;
            }
          }
        }, [_c('td', [_vm._v(_vm._s(props.item.projectId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.customerNameFromID(props.item.Customer)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatDate")(props.item.CreatedDate))), (props.item.CreatedDate == _vm.today) ? _c('v-chip', {
          attrs: {
            "color": "green",
            "text-color": "white",
            "small": ""
          }
        }, [_vm._v("New")]) : _vm._e()], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.supplierNameFromID(props.item.Supplier)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.Status ? props.item.Status : 'Awaiting Approval'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.financeCustomer ? props.item.financeCustomer : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.financeSupplier ? props.item.financeSupplier : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.supplierCost ? '£' + props.item.supplierCost : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.supplierPaid ? '£' + props.item.supplierPaid : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.financeInvoiced ? '£' + props.item.financeInvoiced : ''))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.editProject(props.item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "teal"
          }
        }, [_vm._v("edit")])], 1), _vm._v(" "), _c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.deleteProjectModal(props.item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "pink"
          }
        }, [_vm._v("delete")])], 1)], 1)])]
      }
    }, {
      key: "expand",
      fn: function(props) {
        return [_c('v-layout', {
          attrs: {
            "justify-center": ""
          }
        }, [_c('v-flex', {
          attrs: {
            "xs12": ""
          }
        }, [_c('v-card', {
          staticClass: "ma-2 elevation-0",
          attrs: {
            "width": "100%"
          }
        }, [_c('v-flex', {
          attrs: {
            "xs8": ""
          }
        }, [_c('v-list', {
          attrs: {
            "dark": "",
            "dense": ""
          }
        }, [_c('v-list-tile', [_c('v-layout', [_c('v-flex', {
          attrs: {
            "xs3": ""
          }
        }, [_c('v-list-tile-content', [_vm._v("\n                          Status\n                        ")])], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs3": ""
          }
        }, [_c('v-list-tile-content', [_vm._v("\n                          Vehicle\n                        ")])], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs3": ""
          }
        }, [_c('v-list-tile-content', [_vm._v("\n                          Date\n                        ")])], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs3": ""
          }
        }, [_c('v-list-tile-content', [_vm._v("\n                          Job Number\n                        ")])], 1)], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._l((_vm.expandedJobs(props.item.projectId)), function(job, i) {
          return _c('v-list-tile', {
            key: i
          }, [_c('v-layout', [_c('v-flex', {
            attrs: {
              "xs3": ""
            }
          }, [_c('v-list-tile-avatar', [_c('v-icon', {
            attrs: {
              "color": job.Status >= 2 ? 'green' : job.Status === 1 ? 'red' : (job.Supplier === '' || job.Supplier === null) ? 'grey' : (job.Allocated === '' || job.Allocated === null) ? 'cyan' : 'orange'
            }
          }, [_vm._v("assignment")])], 1)], 1), _vm._v(" "), _c('v-flex', {
            attrs: {
              "xs3": ""
            }
          }, [_c('v-list-tile-content', [_vm._v("\n                          " + _vm._s(job.Vehicle ? _vm.vehicleRegFromID(job.Vehicle) : job.vehReg) + "\n                        ")])], 1), _vm._v(" "), _c('v-flex', {
            attrs: {
              "xs3": ""
            }
          }, [_c('v-list-tile-content', [_vm._v("\n                          " + _vm._s(_vm._f("formatDate")(job.Date)) + "\n                        ")])], 1), _vm._v(" "), _c('v-flex', {
            attrs: {
              "xs3": ""
            }
          }, [_c('v-list-tile-content', [_vm._v("\n                          " + _vm._s(job.JobNo) + "\n                        ")])], 1)], 1)], 1)
        })], 2)], 1), _vm._v(" "), _c('v-flex', {
          staticClass: "mt-3",
          attrs: {
            "xs12": ""
          }
        }, [_c('v-btn', {
          staticClass: "primary",
          attrs: {
            "depressed": ""
          },
          on: {
            "click": function($event) {
              return _vm.exportFinance(props.item.projectId)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "left": ""
          }
        }, [_vm._v("mdi-content-copy")]), _vm._v("Copy Table")], 1)], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs12": ""
          }
        }, [_c('v-data-table', {
          attrs: {
            "select-all": "",
            "dark": "",
            "headers": _vm.financeHeaders,
            "items": _vm.financeItems,
            "search": _vm.searchFinance,
            "loading": _vm.financeTableLoading,
            "pagination": _vm.financePagination
          },
          on: {
            "update:pagination": function($event) {
              _vm.financePagination = $event
            }
          },
          scopedSlots: _vm._u([{
            key: "items",
            fn: function(props) {
              return [_c('tr', [_c('td', [_c('v-checkbox', {
                attrs: {
                  "primary": "",
                  "hide-details": ""
                },
                model: {
                  value: (props.selected),
                  callback: function($$v) {
                    _vm.$set(props, "selected", $$v)
                  },
                  expression: "props.selected"
                }
              })], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.JobNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.VehicleReg))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.templateNameFromId(props.item.template)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.paymentMethodsString))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.contractTermText))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.currencyText))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.upfrontPayment ? props.item.currencyText + props.item.upfrontPayment : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.installationPayment ? props.item.currencyText + props.item.installationPayment : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.rentalPayment ? props.item.currencyText + props.item.rentalPayment : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.rentalFrequencyText))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.lessorText))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.leasePayment ? props.item.currencyText + props.item.leasePayment : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.leaseFrequencyText))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.warrantyText))])])]
            }
          }], null, true),
          model: {
            value: (_vm.selectedJobs),
            callback: function($$v) {
              _vm.selectedJobs = $$v
            },
            expression: "selectedJobs"
          }
        }, [_vm._v(" "), _c('template', {
          slot: "footer"
        }, [_c('td'), _vm._v(" "), _c('td', [_c('strong', [_vm._v("TOTAL")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.financeItemTotals(props.item.projectId).upfrontPaymentTotal > -1 ? _vm.financeItemTotals(props.item.projectId).upfrontPaymentTotal + 1 : ''))])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.financeItemTotals(props.item.projectId).installationPaymentTotal > -1 ? _vm.financeItemTotals(props.item.projectId).installationPaymentTotal + 1 : ''))])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.financeItemTotals(props.item.projectId).rentalPaymentTotal > -1 ? _vm.financeItemTotals(props.item.projectId).rentalPaymentTotal + 1 : ''))])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.financeItemTotals(props.item.projectId).leasePaymentTotal > -1 ? _vm.financeItemTotals(props.item.projectId).leasePaymentTotal + 1 : ''))])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')])], 2)], 1)], 1)], 1)], 1), _vm._v(" "), (props.item.attachedDocs) ? _c('v-layout', {
          attrs: {
            "row": "",
            "wrap": ""
          }
        }, [_c('v-flex', {
          attrs: {
            "xs12": ""
          }
        }, [_c('v-card', {
          staticClass: "my-2 pa-2 elevation-0",
          attrs: {
            "width": "100%"
          }
        }, [_c('v-list', {
          staticClass: "mt-3",
          attrs: {
            "avatar": ""
          }
        }, [_c('h5', {
          staticClass: "title"
        }, [_vm._v("Attached Documents")]), _vm._v(" "), _vm._l((props.item.attachedDocs), function(doc) {
          return _c('v-list-tile', {
            key: doc.name
          }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("mdi-file-document-outline")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_c('a', {
            attrs: {
              "href": doc.downloadUrl,
              "target": "_BLANK"
            }
          }, [_vm._v(_vm._s(doc.name))])])], 1)], 1)
        })], 2)], 1)], 1)], 1) : _vm._e()]
      }
    }]),
    model: {
      value: (_vm.selectedProject),
      callback: function($$v) {
        _vm.selectedProject = $$v
      },
      expression: "selectedProject"
    }
  })], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "750px",
      "scrollable": ""
    },
    model: {
      value: (_vm.deleteProjectDialog),
      callback: function($$v) {
        _vm.deleteProjectDialog = $$v
      },
      expression: "deleteProjectDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Delete Project")])]), _vm._v(" "), _c('v-card-text', [_vm._v("Please confirm whether you would also like to delete the related jobs with the project. Alternatively, you may want\n        to cancel the project instead of deleting it.")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red darken-1",
      "flat": "",
      "loading": _vm.deletingProjectOnly,
      "disabled": _vm.deletingProjectAll || _vm.cancelProject
    },
    nativeOn: {
      "click": function($event) {
        return _vm.deleteProject(false)
      }
    }
  }, [_vm._v("Delete project only")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "red darken-1",
      "flat": "",
      "loading": _vm.deletingProjectAll,
      "disabled": _vm.deletingProjectOnly || _vm.cancelProject
    },
    nativeOn: {
      "click": function($event) {
        return _vm.deleteProject(true)
      }
    }
  }, [_vm._v("Delete project and jobs")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "orange darken-1",
      "flat": "",
      "loading": _vm.cancelProject,
      "disabled": _vm.deletingProjectAll || _vm.deletingProjectOnly
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancelProject($event)
      }
    }
  }, [_vm._v("Cancel Project")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "right": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.deleteProjectDialog = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "750px",
      "scrollable": ""
    },
    model: {
      value: (_vm.editFinanceDialog),
      callback: function($$v) {
        _vm.editFinanceDialog = $$v
      },
      expression: "editFinanceDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Edit Finance Options")])]), _vm._v(" "), _c('v-card-text', [_c('v-select', {
    attrs: {
      "multiple": "",
      "items": _vm.paymentMethods,
      "chips": "",
      "label": "Payment Method(s)"
    },
    model: {
      value: (_vm.editFinance['paymentMethods']),
      callback: function($$v) {
        _vm.$set(_vm.editFinance, 'paymentMethods', $$v)
      },
      expression: "editFinance['paymentMethods']"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "label": "Contact Term",
      "items": _vm.contractTerms
    },
    model: {
      value: (_vm.editFinance['contractTerm']),
      callback: function($$v) {
        _vm.$set(_vm.editFinance, 'contractTerm', $$v)
      },
      expression: "editFinance['contractTerm']"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "label": "Currency",
      "items": _vm.currencies
    },
    model: {
      value: (_vm.editFinance['currency']),
      callback: function($$v) {
        _vm.$set(_vm.editFinance, 'currency', $$v)
      },
      expression: "editFinance['currency']"
    }
  }), _vm._v(" "), (_vm.editFinance['paymentMethods'].includes('upfront-payment')) ? _c('v-text-field', {
    attrs: {
      "label": "Upfront Payment Per Unit",
      "type": "number",
      "step": "0.01"
    },
    model: {
      value: (_vm.editFinance['upfrontPayment']),
      callback: function($$v) {
        _vm.$set(_vm.editFinance, 'upfrontPayment', $$v)
      },
      expression: "editFinance['upfrontPayment']"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editFinance['paymentMethods'].includes('upfront-installation')) ? _c('v-text-field', {
    attrs: {
      "label": "Installation Payment Per Unit",
      "type": "number",
      "step": "0.01"
    },
    model: {
      value: (_vm.editFinance['installationPayment']),
      callback: function($$v) {
        _vm.$set(_vm.editFinance, 'installationPayment', $$v)
      },
      expression: "editFinance['installationPayment']"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editFinance['paymentMethods'].includes('rental')) ? _c('v-text-field', {
    attrs: {
      "label": "Rental Payment Per Unit",
      "type": "number",
      "step": "0.01"
    },
    model: {
      value: (_vm.editFinance['rentalPayment']),
      callback: function($$v) {
        _vm.$set(_vm.editFinance, 'rentalPayment', $$v)
      },
      expression: "editFinance['rentalPayment']"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editFinance['paymentMethods'].includes('rental')) ? _c('v-select', {
    attrs: {
      "label": "Rental Frequency",
      "items": _vm.rentalFrequencies
    },
    model: {
      value: (_vm.editFinance['rentalFrequency']),
      callback: function($$v) {
        _vm.$set(_vm.editFinance, 'rentalFrequency', $$v)
      },
      expression: "editFinance['rentalFrequency']"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editFinance['paymentMethods'].includes('lease')) ? _c('v-select', {
    attrs: {
      "label": "Lessor",
      "items": _vm.lessors
    },
    model: {
      value: (_vm.editFinance['lessor']),
      callback: function($$v) {
        _vm.$set(_vm.editFinance, 'lessor', $$v)
      },
      expression: "editFinance['lessor']"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editFinance['paymentMethods'].includes('lease')) ? _c('v-text-field', {
    attrs: {
      "label": "Lease Payment Per Unit",
      "type": "number",
      "step": "0.01"
    },
    model: {
      value: (_vm.editFinance['leasePayment']),
      callback: function($$v) {
        _vm.$set(_vm.editFinance, 'leasePayment', $$v)
      },
      expression: "editFinance['leasePayment']"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editFinance['paymentMethods'].includes('lease')) ? _c('v-select', {
    attrs: {
      "label": "Lease Frequency",
      "items": _vm.leaseFrequencies
    },
    model: {
      value: (_vm.editFinance['leaseFrequency']),
      callback: function($$v) {
        _vm.$set(_vm.editFinance, 'leaseFrequency', $$v)
      },
      expression: "editFinance['leaseFrequency']"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-select', {
    attrs: {
      "label": "Warranty",
      "items": _vm.warranties
    },
    model: {
      value: (_vm.editFinance['warranty']),
      callback: function($$v) {
        _vm.$set(_vm.editFinance, 'warranty', $$v)
      },
      expression: "editFinance['warranty']"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.selectedJobs = [];
        _vm.editFinanceDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "flat": "",
      "loading": _vm.savingEditedFinance
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveEditedFinance($event)
      }
    }
  }, [_vm._v("Save Changes")])], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": 5000,
      "color": "info",
      "top": ""
    },
    model: {
      value: (_vm.copied),
      callback: function($$v) {
        _vm.copied = $$v
      },
      expression: "copied"
    }
  }, [_vm._v("\n    Table copied to clipboard\n    "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.copied = false
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedJobs.length > 0),
      expression: "selectedJobs.length > 0"
    }],
    attrs: {
      "color": "primary",
      "dark": "",
      "fab": "",
      "fixed": "",
      "bottom": "",
      "right": ""
    },
    on: {
      "click": _vm.openEditFinanceDialog
    }
  }, [_c('v-icon', [_vm._v("edit")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f3bc2ae6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Finance.vue
// module id = 768
// module chunks = 1